import { render, staticRenderFns } from "./MjknReportingDashboard.vue?vue&type=template&id=48dcff61&scoped=true"
import script from "./MjknReportingDashboard.vue?vue&type=script&lang=js"
export * from "./MjknReportingDashboard.vue?vue&type=script&lang=js"
import style0 from "./MjknReportingDashboard.vue?vue&type=style&index=0&id=48dcff61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dcff61",
  null
  
)

export default component.exports